import { render, staticRenderFns } from "./SatiraSection.vue?vue&type=template&id=d7dc52d6&scoped=true&"
import script from "./SatiraSection.vue?vue&type=script&lang=js&"
export * from "./SatiraSection.vue?vue&type=script&lang=js&"
import style0 from "./SatiraSection.vue?vue&type=style&index=0&id=d7dc52d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7dc52d6",
  null
  
)

export default component.exports